import React, {Component} from 'react'
import {Layout, Menu, Icon, Avatar, Button} from 'antd';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

const {Sider} = Layout;

const SubMenu = Menu.SubMenu;

const RTLMenu = styled(Menu)`
  border-right: unset !important;
`;

const RTLMenuItem = styled(Menu.Item)`
    font-size: 12px !important;
    &::after {
        left: 0 !important;
        right: unset !important
    }
    &[style] {
        padding-left: unset !important;
        xcolor: #9facbd !important;
    }
    & .anticon {
        margin-left: 10px !important;
        margin-right: 0 !important;
    }
`;

const RTLSubMenu = styled(SubMenu)`
    & .ant-menu-submenu-title {
      & span {
        & i.anticon {
          margin-right: unset !important;
          margin-left: 10px !important;
        }
        & span {
          font-size: 12px !important;
        }
      }
      padding-left: unset !important;
      padding-right: 16px !important;
      xcolor: #9facbd !important;
      & .ant-menu-submenu-arrow {
        right: unset !important;
        left: 15px;
      }
    }
`;

const RTLButton = styled(Button)`
    font-size:13px !important;
    & span {
        margin-left: unset !important;
        margin-right:4px;
    }
    & i {
        margin-top: 2px;
    }
`;


class SideNavigation extends Component {
    state = {
        collapsed: false
    };

    getRandomName = (count) => {
        var listEmail = []
        for (var i = 0; i < count; i++) {
            listEmail.push([...Array(10)].map(i => (~~(Math.random() * 36)).toString(36)).join('') + '@gmail.com')
        }
        return listEmail;
    }
    onCollapse = (collapsed) => {
        this.setState({collapsed});
    };

    __onOpenChange(e){
        console.log('e',e)

    }

    render() {
        const listEmail = this.getRandomName(10);
        return (
            <Sider
                theme="light"
                collapsible
                collapsed={this.state.collapsed}
                onCollapse={this.onCollapse}
                reverseArrow="true"
            >
                <RTLMenu defaultSelectedKeys={['sub1']} mode="inline"
                         style={{borderRight: 'none !important', fontWeight: '500'}}
                >
                    <RTLSubMenu
                        key="sub1"
                        title={<span><Icon type="user"/><span>مدیریت کاربران</span></span>}
                    >
                        <RTLMenuItem key="1">
                            <Link to="/user/add"> ایجاد کاربر</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="2">
                            <Link to="/user/list">لیست کاربران </Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub2"
                        title={<span><Icon type="global" /><span>مدیریت مناطق</span></span>}
                    >
                        <RTLMenuItem key="3">
                            <Link to="/state/add"> ایجاد استان</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="4">
                            <Link to="/state/list">لیست استان ها </Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="5">
                            <Link to="/city/add"> ایجاد شهر</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="6">
                            <Link to="/city/list">لیست شهر ها </Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub3"
                        title={<span><Icon type="deployment-unit" /><span>خدمات تکنسین</span></span>}
                    >
                        <RTLMenuItem key="7">
                            <Link to="/service/add"> ایجاد خدمت تکنسین</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="8">
                            <Link to="/service/list">لیست خدمات تکنسین</Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub4"
                        title={<span><Icon type="cluster" /><span>مدیریت محصولات</span></span>}
                    >
                        <RTLMenuItem key="9">
                            <Link to="/product-category/add"> ایجاد دسته بندی</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="10">
                            <Link to="/product-category/list">لیست دسته بندی ها </Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="11">
                            <Link to="/product/add"> ایجاد محصولات</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="12">
                            <Link to="/product/list">لیست محصولات </Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub5"
                        title={<span><Icon type="solution" /><span>خدمات قابل ارائه</span></span>}
                    >
                        <RTLMenuItem key="13">
                            <Link to="/fixture/add"> ایجاد خدمت قابل ارائه</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="14">
                            <Link to="/fixture/list">لیست خدمت قابل ارائه</Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub7"
                        title={<span><Icon type="transaction" /><span>تراکنش</span></span>}
                    >
                        <RTLMenuItem key="18">
                            <Link to="/transaction/list">لیست تراکنش ها</Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub8"
                        title={<span><Icon type="snippets" /><span>درخواست ها</span></span>}
                    >
                        <RTLMenuItem key="19">
                            <Link to="/order/list">لیست درخواست ها</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="20">
                            <Link to="/order/add">ایجاد درخواست</Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub9"
                        title={<span><Icon type="credit-card" /><span>حسابداری</span></span>}
                    >
                        <RTLMenuItem key="21">
                            <Link to="/bank/add"> ایجاد بانک</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="22">
                            <Link to="/bank/list">لیست بانک ها</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="23">
                            <Link to="/document/add"> ایجاد سند</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="24">
                            <Link to="/document/list">لیست اسناد</Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub10"
                        title={<span><Icon type="bell" /><span>تعویض دوره ای</span></span>}
                    >
                        <RTLMenuItem key="25">
                            <Link to="/reminder">تعویض دوره ای</Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub11"
                        title={<span><Icon type="setting" /><span>تنظیمات</span></span>}
                    >
                        <RTLMenuItem key="26">
                            <Link to="/settings">تنظیمات</Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub12"
                        title={<span><Icon type="bar-chart" /><span>گزارشات</span></span>}
                    >
                        <RTLMenuItem key="27">
                            <Link to="/report/pos">گزارش کارتخوان</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="28">
                            <Link to="/report/technician">گزارش عملکرد تکنسین</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="35">
                            <Link to="/report/products">گزارش محصولات تکنسین</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="29">
                            <Link to="/report/city">گزارش عملکرد شهرها</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="30">
                            <Link to="/report/state">گزارش عملکرد استان ها</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="31">
                            <Link to="/report/rate">گزارش میانگین امتیازات</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="32">
                            <Link to="/report/invoice">گزارش فاکتور های تسویه شده</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="33">
                            <Link to="/report/tickets">گزارش تیکت ها</Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                    <RTLSubMenu
                        key="sub13"
                        title={<span><Icon type="like" /><span>استعلام گارانتی</span></span>}
                    >
                        <RTLMenuItem key="34">
                            <Link to="/guarantee/inquiry">استعلام گارانتی سفارشات</Link>
                        </RTLMenuItem>
                        <RTLMenuItem key="35">
                            <Link to="/guarantee">محصولات گارانتی دار</Link>
                        </RTLMenuItem>
                    </RTLSubMenu>
                </RTLMenu>
            </Sider>
        );
    }
}

export default SideNavigation;
